import { PacmanLoader } from "react-spinners";
import { default as React } from "react";
import { Button, Col, Row, Modal, Alert } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import { Link } from "react-router-dom";
import { GenericTable } from "components/GenericTable";
import EditableCell from "containers/common/EditableCell";
import "containers/common/List.css";
import "containers/common/Table.css";

import {
  createColumnHelper,
} from "@tanstack/react-table";

function ProposalList({
  data,
  isLoading,
  isAuthenticated,
  controlType,
  saveRecord,
  deleteRecord,
  updateTableState,
  proposalid,
  user,
  idList,
  areaSum,
  propertykey,
  propertyid,
}) {

  const dataSet = 'propertyProposals';
  // const [dataRecord, setDataRecord] = useState("propertyProposals");
  // const [dataSetPrimaryKey, setDataSetPrimaryKey] = useState(
  //   "property_proposal_id"
  // );  

  // --- TanStack Table Setup ---
  const tableData = data || [];
  const columnHelper = createColumnHelper();
  const isLegacyProposalDetailTable = controlType === "table2";
  const [showAlert, setShowAlert] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState("");

  const savePropertyProposal = async (record) => {
    if (isLegacyProposalDetailTable) {
      return saveRecord(record, "propertyProposals", "property_proposal_id");
    }

    return saveRecord(dataSet, record);
  };

  const applyProposalRules = (rowRecord, columnId, nextValue, showAlerts = false) => {
    const updatedRecord = {
      ...(rowRecord || {}),
      ...(columnId ? { [columnId]: nextValue } : {}),
      modified: true,
    };

    if (columnId === "proceeded" && nextValue === true) {
      if (showAlerts) {
        alert("You have selected that the proposal is completed so the current and include in text flags have been set to false");
      }
      updatedRecord.current = false;
      updatedRecord.include_in_text = false;
      updatedRecord.approved = true;
    }

    if ((columnId === "current" || columnId === "include_in_text") && nextValue === true && rowRecord?.proceeded === true) {
      if (showAlerts) {
        alert("The proposal was completed but you selected that it is current or to include in text. The completed flag has been set to false");
      }
      updatedRecord.proceeded = false;
    }

    return updatedRecord;
  };

  const tableMeta = {
    updateData: (rowIndex, columnId, value) => {
      const nextRows = [...tableData];
      const baseRecord = nextRows[rowIndex] || {};
      const nextRecord = applyProposalRules(baseRecord, columnId, value, true);
      nextRows[rowIndex] = nextRecord;
      updateTableState(nextRows, dataSet);
    },
    handleSave: async ({ row, column, value }) => {
      const baseRecord = {
        ...(tableData[row.index] || {}),
        ...row.original,
      };

      const record = applyProposalRules(baseRecord, column?.id, value, false);
      record.last_edited_by = user;

      try {
        const result = await savePropertyProposal(record);
        if (result?.result === false) {
          setErrorMessage(result?.error_message || "Save failed");
          setShowAlert(true);
          return { saveFailed: true };
        }
        setShowAlert(false);
        setErrorMessage("");
        console.log("Record saved successfully via parent logic");
      } catch (err) {
        console.error("Save failed:", err);
        setErrorMessage(err?.message || "Save failed");
        setShowAlert(true);
        return { saveFailed: true };
      }
    },
    handleDelete: async ({ row }) => {
      const confirmed = window.confirm("Are you sure you want to delete this record?");
      if (confirmed) {
        if (isLegacyProposalDetailTable) {
          const recordToArchive = {
            ...row.original,
            archived_date: new Date(),
            last_edited_by: user,
            modified: true,
          };

          const result = await savePropertyProposal(recordToArchive);
          if (result?.result === false) {
            setErrorMessage(result?.error_message || "Delete failed");
            setShowAlert(true);
            return;
          }
          setShowAlert(false);
          setErrorMessage("");
          const nextRows = tableData.filter((_, rowIndex) => rowIndex !== row.index);
          updateTableState(nextRows, dataSet);
        } else {
          deleteRecord(dataSet, row.original);
        }
      }
    },
  };

  // const col_ = columnHelper.accessor("xxx", {
  //         id: "xxx",
  //         header: "xxx",
  //         cell: Editablecell,
  //         size: 60,
  //     });

  const columns = [
    columnHelper.accessor("proposal_id", {
      id: "proposal_id",
      header: "ID",
      cell: (e) => (
        <Link
          to={`/properties/${e.row.original.property_key}/proposals/${e.getValue()}`}
          state={{
            data: data.map((a) => a.proposal_id),
            propertyidlist: idList,
          }}
        >
          {e.getValue()}
        </Link>
      ),
      size: 60,
    }),
    columnHelper.accessor("source_date", {
      id: "source_date",
      header: "Source Date",
      cell: EditableCell,
    }),
    columnHelper.accessor("current", {
      id: "current",
      header: "Current",
      cell: EditableCell,
      size: 76,
      meta: { type: "checkbox" },
    }),
    columnHelper.accessor("include_in_text", {
      id: "include_in_text",
      header: "In Text",
      cell: EditableCell,
      size: 74,
      meta: { type: "checkbox" },
    }),
    columnHelper.accessor("proceeded", {
      id: "proceeded",
      header: "Proceeded",
      cell: EditableCell,
      size: 92,
      meta: { type: "checkbox" },
    }),
    columnHelper.accessor("proposal", {
      id: "proposal",
      header: "Proposal",
      cell: EditableCell,
      size: 260,
      meta: {
        inputType: "textarea",
        rows: 2,
        resize: "vertical",
      },
    }),
    columnHelper.accessor("alternate_text", {
      id: "alternate_text",
      header: "Alternate Text",
      cell: EditableCell,
      size: 220,
    }),
    columnHelper.accessor("property_proposal_id", {
      id: "property_proposal_id",
      header: "",
      cell: ({ row }) =>
        <Button type="button" size="sm" variant="danger" onClick={() => tableMeta.handleDelete({ row })}>
          Delete
        </Button>,
      size: 60,
    }),
  ];

  const columns2 = [
    columnHelper.display({
      id: "back_to_property",
      header: "",
      cell: (e) => (
        <Link to={`/properties/${e.row.original.property_key}`}>
          <Button type="button" size="sm" variant="primary">
            Back
          </Button>
        </Link>
      ),
      size: 60,
    }),
    columnHelper.accessor("property_key", {
      id: "property_key",
      header: "Cityscope Ref",
      cell: EditableCell,
      size: 100,
    }),
    columnHelper.accessor("main_property_address", {
      id: "main_property_address",
      header: "Main Property Address",
      cell: (e) => {
        const addresses = e.row.original.addresses;
        if (!addresses || addresses.length === 0) {
          return <span></span>;
        }

        const mainAddress = addresses.find((a) => a.main_address === true);
        if (!mainAddress) {
          return <span></span>;
        }

        return <span>{`${mainAddress.street_address}, ${mainAddress.suburb}`}</span>;
      },
      size: 150,
      meta: { wrap: true },
    }),
    columnHelper.accessor("alternate_text", {
      id: "alternate_text",
      header: "Alternate Text",
      cell: EditableCell,
      size: 120,
      meta: { wrap: true },
    }),
    columnHelper.accessor("site_area", {
      id: "site_area",
      header: "Site Area",
      cell: (info) => info.getValue(),
      size: 100,
      footer: "Total: " + areaSum,
      meta: { cellStyle: { textAlign: "right" } },
    }),
    columnHelper.accessor("title_details", {
      id: "title_details",
      header: "Title",
      cell: (info) => info.getValue(),
      size: 140,
      meta: { wrap: true },
    }),
    columnHelper.accessor("property_proposal_id", {
      id: "property_proposal_id",
      header: "",
      cell: ({ row }) =>
        <Button type="button" size="sm" variant="danger" onClick={() => tableMeta.handleDelete({ row })}>
          Delete
        </Button>,
      size: 60,
    }),
  ];

  // --- Data Fetching and Update Functions ---
  // const handleInputChange = (cellInfo, event) => {
  //   let localdata = [...data];
  //   localdata[cellInfo.row.index][cellInfo.column.id] = event.target.value;
  //   localdata[cellInfo.row.index].modified = true;
  // };

  // const handleNumberChange = (cellInfo, event) => {
  //   let localdata = [...data];
  //   let val = event.target.value.replace(/[^0-9]/g, "");
  //   localdata[cellInfo.row.index][cellInfo.column.id] = val;
  //   localdata[cellInfo.row.index].modified = true;
  // };

  // const handleCheckboxChange = (cellInfo, event) => {
  //   let localdata = [...data];
  //   localdata[cellInfo.row.index][cellInfo.column.id] = event.target.checked;
  //   localdata[cellInfo.row.index].modified = true;
  //   if (cellInfo.column.id === "proceeded") {
  //     if (event.target.checked) {
  //       alert(
  //         "You have selected that the proposal is completed so the current and include in text flags have been set to false"
  //       );
  //       localdata[cellInfo.row.index].current = false;
  //       localdata[cellInfo.row.index].include_in_text = false;
  //       localdata[cellInfo.row.index].approved = true;
  //     }
  //   }

  //   if (
  //     cellInfo.column.id === "current" ||
  //     cellInfo.column.id === "include_in_text"
  //   ) {
  //     if (event.target.checked) {
  //       console.log(cellInfo.original);
  //       if (cellInfo.original.proceeded === true) {
  //         alert(
  //           "The proposal was completed but you selected that it is current or to include in text. The completed flag has been set to false"
  //         );
  //         localdata[cellInfo.row.index].proceeded = false;
  //       }
  //     }
  //   }
  //   // setUsers(localusers);
  //   handleSave(cellInfo, event);
  // };

  // const handleDateChange = (cellInfo, event) => {
  //   let localdata = [...data];
  //   var options = { year: "numeric", month: "long", day: "numeric" };
  //   var dt = new Date(event);
  //   localdata[cellInfo.row.index][cellInfo.column.id] = dt.toLocaleDateString(
  //     "en-AU",
  //     options
  //   );
  //   localdata[cellInfo.row.index].modified = true;
  //   // setUsers(localusers);
  //   handleSave(cellInfo, event);
  // };

  // function handleBlur(cellInfo, event) {
  //   // let localausuburbs = [...ausuburbs];

  //   // console.log("On Blur: " + localausuburbs[cellInfo.row.index].new_record);
  //   // if (
  //   //   cellInfo.column.id === "cityscope" &&
  //   //   localausuburbs[cellInfo.row.index].new_record
  //   // ) {
  //   //   return;
  //   // }
  //   // handleSave(cellInfo, event);
  // }

  // const handleSave = async (cellInfo, event) => {
  //   // setShowAlert(false);
  //   // let localdata = [...data];
  //   // const i = [cellInfo.row.index]

  //   //   const validation = validateRelatedRecord(localdata[i], dataSet);
  //   //   console.log(validation[0]);
  //   //   if (validation[0] === true) {
  //   //     if (localdata[i].hasOwnProperty("modified")) {
  //   //       if (localdata[i].modified === true) {
  //   //         console.log(i);
  //   //         //Save the data
  //   //         if (!savingNewRecord) {
  //   //           if (localdata[i].hasOwnProperty("new_record")) {
  //   //             if (localdata[i].new_record === true) {
  //   //               setSavingNewRecord(true);
  //   //             }
  //   //           }
  //   //           const result = await handleDataSave(localdata[i]);
  //   //           if (result.result) {
  //   //             localdata[i].modified = false;
  //   //             if (localdata[i].hasOwnProperty("new_record")) {
  //   //               if (localdata[i].new_record === true) {
  //   //                 localdata[i][dataSetPrimaryKey] = result.id;
  //   //                 setSavingNewRecord(false);
  //   //               }
  //   //               localdata[i].new_record = false;
  //   //             }
  //   //           } else {
  //   //             setErrorMessage(result.error_message);
  //   //             setShowAlert(true);
  //   //           }
  //   //         }
  //   //     }
  //   //   } else {
  //   //     setErrorMessage(validation[1]);
  //   //     setShowAlert(true);
  //   //   }
  //   // }
  //   // if (localdata[0].hasOwnProperty("source_date")) {
  //   //   localdata.sort(function (a, b) {
  //   //     return new Date(b.source_date) - new Date(a.source_date);
  //   //   });
  //   // }
  //   // if (localdata[0].hasOwnProperty("current")) {
  //   //   localdata.sort(function (a, b) {
  //   //     return a.current === b.current ? 0 : a.current ? -1 : 1;
  //   //   });
  //   // }

  //   // updateTableState(localdata, dataSet);
  // };

  const addRecord = async (event) => {
    let localdata = [...data];

    //Update the following with the minimum details to create a record (all not nulls populated)
    //Requires updating per dataset
    localdata.unshift({
      property_id: null,
      property_key: "",
      addresses: null,
      proposal_id: proposalid,
      alternate_text: "",
      created_by: user,
      last_edited_by: user,
      new_record: true,
    });
    updateTableState(localdata, dataSet);
  };

  function renderComponent() {
    const activeColumns = controlType === "table2" ? columns2 : columns;

    return (
      <div className="proposals">
        <Modal show={showAlert} onHide={() => setShowAlert(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>Uh Oh!</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Alert variant="danger" className="mb-0">
              {errorMessage}
            </Alert>
          </Modal.Body>
        </Modal>

        {(controlType === "table" || controlType === "table2") && (
          <Row>
            <Col className="text-right">
              {/*   <Button variant="secondary" size="sm" onClick={refreshDataSet}  >Refresh</Button>  */}
              {controlType === "table" && (
                <Link
                  to={`/properties/${propertykey}/proposals/new?propertyid=${propertyid}`}
                >
                  <Button variant="secondary" size="sm">
                    Add
                  </Button>
                </Link>
              )}
              {controlType === "table2" && (
                <Button variant="secondary" size="sm" onClick={addRecord}>
                  Add
                </Button>
              )}
            </Col>
          </Row>
        )}

        <Row className="show-Container">
          <Col sm={12} md={12} lg={12}>
            {isLoading ? (
              <div className="outer-div">
                <div className="sweet-loading inner-div">
                  <PacmanLoader
                    cssOverride={{ display: "block", margin: "0 auto" }}
                    size={20}
                    color={"#e03c31"}
                    loading={isLoading}
                  />
                </div>
              </div>
            ) : (
              <GenericTable
                columns={activeColumns}
                data={tableData}
                pageSize={10}
                enablePagination={true}
                hasHeaderSorting={true}
                meta={tableMeta}
              />
            )}
          </Col>
        </Row>
      </div>
    );
  }
  return (
    <div className="ProposalList">
      {isAuthenticated ? renderComponent() : console.log("User not authenticated.")}
    </div>
  );
}

export default ProposalList;
